module.exports = __webpack_public_path__ + "static/media/loading.90073aa0.svg";